import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const items = [
    "Periodontology",
    "Oral Implantology",
    "Cosmetic Dentistry",
    "Dibdih · Ranchi",
    "Since Care Began",
    "Dr. Shikha Sinha",
];

export const MarqueeBand = () => {
    return (
        <section
            className="border-y border-surya-line bg-surya-surface py-4 md:py-8 overflow-hidden relative z-[2]"
            data-testid="marquee-band"
            aria-label="Specialisations marquee"
        >
            <Marquee gradient={false} speed={30} pauseOnHover>
                <div className="marquee-inner flex items-center">
                    {items.concat(items).map((word, i) => (
                        <span
                            key={i}
                            className="font-serif text-[1.4rem] md:text-[2.8rem] leading-none tracking-tight text-surya-ink font-light inline-flex items-center gap-4 md:gap-8"
                        >
                            <span className={i % 2 === 1 ? "italic-display text-surya-orange" : ""}>
                                {word}
                            </span>
                            <Sparkle
                                className="h-3 w-3 md:h-4 md:w-4 text-surya-orange"
                                strokeWidth={1.2}
                            />
                        </span>
                    ))}
                </div>
            </Marquee>
        </section>
    );
};
